// ABOUTME: Notification ribbon for pending Make It Right approvals
// ABOUTME: Shows at top of parent view, smooth scrolls to first approval button on click

import React, { useState, useEffect } from 'react';
import { Alert, Chip } from '@mui/material';
import { ChoreListType, ChoreListStatus, ChoreListPeriodStatus } from '../types/api';

interface MakeItRightApprovalRibbonProps {
  childChoreStatuses: Record<number, ChoreListPeriodStatus[]>;
}

const MakeItRightApprovalRibbon: React.FC<MakeItRightApprovalRibbonProps> = ({ childChoreStatuses }) => {
  const [isDismissed, setIsDismissed] = useState(false);

  // Count pending approvals across all children
  const pendingCount = Object.values(childChoreStatuses)
    .flat()
    .filter(list => list.type === ChoreListType.MakeItRight && list.status === ChoreListStatus.PendingApproval)
    .length;

  // Reset dismiss state when pending count changes
  useEffect(() => {
    if (pendingCount > 0) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- intentionally resets dismiss state when new items appear
      setIsDismissed(false);
    }
  }, [pendingCount]);

  if (pendingCount === 0 || isDismissed) return null;

  const handleClick = () => {
    // Scroll to first approval button
    const approvalButton = document.querySelector('[data-approval-button]');
    if (approvalButton) {
      approvalButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <Alert
      data-testid="make-it-right-approval-ribbon"
      severity="warning"
      variant="filled"
      sx={{
        mb: 3,
        cursor: 'pointer'
      }}
      onClick={handleClick}
      action={
        <Chip
          label={pendingCount}
          size="small"
          sx={{ bgcolor: 'warning.light', color: 'warning.contrastText' }}
        />
      }
    >
      {pendingCount === 1
        ? '✋ 1 Make It Right list ready for approval!'
        : `✋ ${pendingCount} Make It Right lists ready for approval!`
      }
    </Alert>
  );
};

export default MakeItRightApprovalRibbon;
